import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import styles from './spinner.module.scss';

type SpinnerProps = {
  colour?: string | null | undefined,
  cssClass?: string | null | undefined,
  fillScreen?: boolean | null | undefined,
  delayShowSeconds?: number | undefined,
  showBg?: boolean | null | undefined
}

/**
 * A spinner
 * @param {string} [props.colour]
 * @param {string} [props.cssClass]
 * @param {boolean} [props.fillScreen]
 * @param {number} [props.delayShowSeconds]
 * @param {boolean} [props.showBg]
 * @returns {JSX.Element}
 */
export const Spinner: React.FC<SpinnerProps> = ({ colour = 'white', cssClass = null, fillScreen = false, delayShowSeconds = 0, showBg = false }) => {
  const [show, setShow] = useState(0);
  const spin = <div className={classNames(styles.spinner, cssClass ? cssClass : '')} style={{ borderTopColor: `${colour}`, opacity: show }} />;
  const timeout = useRef<number | null>(null);

  useEffect(() => {
    timeout.current = window.setTimeout(() => setShow(1), delayShowSeconds !== undefined ? delayShowSeconds * 1000 : 0);
    return () => {
      if (timeout.current) clearTimeout(timeout.current)
    }
  }, [delayShowSeconds]);

  if (fillScreen) {
    return (
      <div className={classNames(styles.spinnerHarness, showBg ? styles.spinnerHarnessBlurBg : '')}>
        {
          showBg && <div className={styles.spinnerHarnessBg} />
        }
        {spin}
      </div>
    )
  }
  else return spin;
};
